import React, { useCallback, useMemo } from 'react';
import { Badge } from 'components/shadcn/ui/badge';
import { LightTooltip } from 'components/HGTooltip';
import { CheckIcon } from '@heroicons/react/24/outline';

const HGVerified = ({ verified, type, ...rest }) => {
    const getStatusColorAndContent = useCallback(() => {
        let colorAndContent = {
            color: 'secondary',
            content: 'loading',
        };

        if (verified === 'verified' || verified === true) {
            colorAndContent = {
                color: 'success',
                content: 'verified',
            };
        }
        if (verified !== 'verified' || verified === false) {
            colorAndContent = {
                color: 'error',
                content: 'unverified',
            };
        }
        return colorAndContent;
    }, [verified]);

    const { color, content } = useMemo(
        () => getStatusColorAndContent(),
        [getStatusColorAndContent]
    );

    return (
        <LightTooltip
            title={
                verified !== 'verified'
                    ? `The ${type}\'s email is not verified as a valid user`
                    : 'verified'
            }
            placement="top"
            arrow
            enterDelay={500}
            leaveDelay={200}
            offsetLeft={1}
        >
            {content === 'verified' ? (
                <CheckIcon className="w-4 h-4 text-info" />
            ) : (
                <Badge
                    circular={true}
                    color={color}
                    className="my-1"
                >
                    {content}
                </Badge>
            )}
        </LightTooltip>
    );
};

export default HGVerified;
